export default __webpack_public_path__ + "assets/images/c40959789e85c90d431dcf6e9bda2355.png";